export const subscribedPackageLoading =  ({store})  => store.subscribedPackageReducer.loading;

export const subscribedPackageError =  ({store})  => store.subscribedPackageReducer.error;

export const subscribedPackageData =  ({store})  => store.subscribedPackageReducer;